import React from 'react';
import 'twin.macro';
import { Link } from 'gatsby';

import { PortableText } from '../elements';
import { Heading, Subtitle, Button } from '../atoms';

const ServiceLevels = ({ serviceLevelItem = [] }) => {
  return (
    <div tw="relative bg-slate pt-16 pb-14 px-8 sm:px-6 lg:pt-14 lg:pb-14 lg:px-10">
      <div tw="relative max-w-7xl mx-auto">
        <div tw="my-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none">
          {serviceLevelItem &&
            serviceLevelItem.map((item) => (
              <div tw="flex flex-col rounded-lg shadow-lg overflow-hidden">
                <div tw="flex-1 bg-white p-10 flex flex-col justify-between text-center">
                  <Heading tw="text-black mb-1">{item.title}</Heading>
                  <Subtitle tw="text-xl font-bold mb-1">{`£${item.price}`}</Subtitle>
                  <Subtitle tw="text-sm text-gray-500 capitalize font-medium">
                    {item.timePeriod}
                  </Subtitle>
                  {item.body && (
                    <p tw="block mt-3 text-base text-gray-500">
                      <PortableText body={item.body} tw="px-0 py-2" />
                    </p>
                  )}
                  <Link to="/contact" tw="mt-6 flex items-center">
                    <Button>Contact us</Button>
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceLevels;
